import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { Link } from "react-router-dom";
import logo from "../../assets/logowhite.svg";
import logo2 from "../../assets/logo.svg";

import { scrollTop } from "../../helpers/PageHelper";
import AuthModal from "../../components/AuthModals/AuthModal";
import kidsnew from "../../assets/new.png";
const user = JSON.parse(localStorage.getItem("USER"));
const role = JSON.parse(localStorage.getItem("ROLE"));

const NavComponent = () => {
  const [openModal, setOpenModal] = useState(false);
  useEffect(() => {
    let scrollpos = window.scrollY;
    const header = document.querySelector("header");
    const logo1 = document.querySelector("#logo1");
    const logo2 = document.querySelector("#logo2");
    const bar = document.querySelector("#bar");
    const header_height = header.scrollHeight;

    const add_class_on_scroll = () => {
      header.classList.add("navbar_fixed");
      logo1.classList.add("logo_display");
      logo2.classList.remove("logo_display");
      bar.classList.remove("bar_color");
    };
    const remove_class_on_scroll = () => {
      header.classList.remove("navbar_fixed");
      logo2.classList.add("logo_display");
      bar.classList.add("bar_color");
      logo1.classList.remove("logo_display");
    };

    window.addEventListener("scroll", function () {
      scrollpos = window.scrollY;
      if (scrollpos >= header_height) {
        add_class_on_scroll();
      } else {
        remove_class_on_scroll();
      }
    });
  }, []);

  const closeModal = () => {
    setOpenModal(false);
  };
  const history = useHistory();
  const location = useLocation();

  const renderListRight = () => {
    return [
      <li
        className="nav-item"
        onClick={scrollTop}
        data-toggle={window.innerWidth < 992 ? "collapse" : ""}
        data-target="#navbarSupportedContent"
        key="2"
      >
        <Link id="homelink" className="nav-link" to="/home">
          home
        </Link>
      </li>,
      // <li
      //   className="nav-item active"
      //   onClick={scrollTop}
      //   data-toggle={window.innerWidth < 992 ? "collapse" : ""}
      //   data-target="#navbarSupportedContent"
      //   key="1"
      // >
      //   <Link id="homelink" className="nav-link" to="/plans">
      //     Plans & pricing
      //   </Link>
      // </li>,
      <li
        className="nav-item "
        onClick={scrollTop}
        data-toggle={window.innerWidth < 992 ? "collapse" : ""}
        data-target="#navbarSupportedContent"
        key="4"
      >
        <Link className="nav-link" to="/plans">
        Spoken English
        </Link>
      </li>,
      <li
        className="nav-item "
        onClick={scrollTop}
        data-toggle={window.innerWidth < 992 ? "collapse" : ""}
        data-target="#navbarSupportedContent"
        key="4"
      >
        <a className="nav-link" href="https://kids.clapingo.com/">
          Kids
        </a>
      </li>,
      <li
        className="nav-item "
        onClick={scrollTop}
        data-toggle={window.innerWidth < 992 ? "collapse" : ""}
        data-target="#navbarSupportedContent"
        key="6"
      >
        <a
          className="nav-link"
          href="https://ielts.clapingo.com/"
        >
          IELTS
        </a>
      </li>,
    //    <li
    //    className="nav-item "
    //    onClick={scrollTop}
    //    data-toggle={window.innerWidth < 992 ? "collapse" : ""}
    //    data-target="#navbarSupportedContent"
    //    key="4"
    //  >
    //    <Link className="nav-link" to="/courses">
    //    Courses<span style={{color:"red", fontSize:"10px", marginLeft:"5px", fontWeight:"bold"}}>NEW</span>
    //    </Link>
    //  </li>

      //   <li
      //   className="nav-item"
      //   onClick={scrollTop}
      //   data-toggle={window.innerWidth < 992 ? "collapse" : ""}
      //   data-target="#navbarSupportedContent"
      //   key="11111113"
      // >
      //   {
      //     location.pathname == '/fb' || location.pathname == '/google'?"":
      //     <div >
      //     <img src={kidsnew} alt="new" />
      //     <a id="teachid" className="nav-link" href="https://kids.clapingo.com/">
      //       Kids
      //     </a>

      //     </div>
      //   }

      // </li>,
    ];
  };

  const renderListLeft = () => {
    return [
      <li
        className="nav-item "
        onClick={scrollTop}
        data-toggle={window.innerWidth < 992 ? "collapse" : ""}
        data-target="#navbarSupportedContent"
        key="1"
      >
        {user && role === "Learner" ? (
          <Link className="signin" to="/session">
            Dashboard
          </Link>
        ) : user && role === "Teacher" ? (
          <Link className="signin" to="/teacher/session">
            Dashboard
          </Link>
        ) : (
          <div className="d-flex">
            {location.pathname == "/fb" || location.pathname == "/google" ? (
              ""
            ) : (
              <>
                <div
                  className="signin mb-3 mb-md-0"
                  onClick={() => history.push("/login")}
                >
                  Log in
                </div>
                <div
                  className="signup mb-3 mb-md-0 ml-1"
                  onClick={() => history.push("/book-demo/:component")}
                >
                  Sign up
                </div>
              </>
            )}
          </div>
        )}
      </li>,
    ];
  };

  return (
    <>
      <AuthModal />
      <div className="auth_model_wrapper">
        <AuthModal openModal={openModal} closeModal={closeModal} />
      </div>

      <header className="header_area ">
        <div className="main_menu">
          <nav className="navbar navbar-expand-lg navbar-light">
            <div className="container">
              <Link to="/" id="logo1">
                <img
                  src={logo2}
                  className="logo m-1 m-md-0"
                  alt="clapingo_logo"
                  onClick={scrollTop}
                />
              </Link>
              <Link
                to="/"
                className="logo_display"
                id="logo2"
                onClick={scrollTop}
              >
                <img
                  src={logo2}
                  className="logo m-1 m-md-0 "
                  alt="clapingo_logo"
                />
              </Link>

              <button
                className="navbar-toggler bar_color"
                id="bar"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className=" fas fa-bars"></span>
              </button>
              <div
                className="collapse navbar-collapse offset"
                id="navbarSupportedContent"
              >
                <ul className="nav navbar-nav menu_nav justify-content-start ml-5 my-auto">
                  {renderListRight()}
                </ul>
                <ul className="nav navbar-nav justify-content-end my-auto">
                  {renderListLeft()}
                </ul>
              </div>
            </div>
          </nav>
        </div>
      </header>
    </>
  );
};

export default NavComponent;
